import { inject, Injectable } from '@angular/core';
import {
  ResolveFn
} from '@angular/router';
import { FascicleService } from '../services/fascicle.service';

export const FascicleResolver: ResolveFn<any> = async (route, state) => {

  const idCatalog = route.paramMap.get('idCatalog');
  const id = route.paramMap.get('id');

  const fascicleService = inject(FascicleService);

  try {
    const breadcrumbs = await fascicleService.getBreadCrumbFascicleList(idCatalog, id);
     // Verificar datos
    return breadcrumbs;
  } catch (error) {
    console.error('Error en el Resolver:', error);
    return []; // Manejo de errores: devuelve un array vacío o un valor por defecto
  }
};